<div class="form-field" [class.mandatory]="item?.isMandatory">
  <label class="field-label" for="">
    {{ item?.title }}
    <span *ngIf="item.isMandatory" class="required">*</span>
  </label>

 

  <!-- TEXT Input -->
  <input
    *ngIf="item.type === FormTabItemTypeEnum.TEXT"
    type="text"
    class="form-input"
    [(ngModel)]="item.answerValue"
    (ngModelChange)="onValueChange($event)"
    [placeholder]="'Lütfen ' + item.title.toLowerCase() + ' giriniz'"
  />

  <!-- NUMBER Input -->
  <input
    *ngIf="item.type === FormTabItemTypeEnum.NUMBER"
    type="number"
    class="form-input"
    [(ngModel)]="item.answerValue"
    (ngModelChange)="onValueChange($event)"
    [placeholder]="'Sayı giriniz'"
  />

  <!-- ID_NUMBER Input -->
  <div *ngIf="item.type === FormTabItemTypeEnum.ID_NUMBER">
    <input
      type="text"
      class="form-input"
      [formControl]="tcknControl"
      placeholder="TC Kimlik No (11 haneli)"
    />
    <div class="text-danger" *ngIf="tcknControl?.hasError('invalidTCKN')">
      {{ "case.patient-informations.invalid-id-number" | translate }}
    </div>
  </div>

  <!-- PHONE_NUMBER Input -->
  <input
    *ngIf="item.type === FormTabItemTypeEnum.PHONE_NUMBER"
    type="tel"
    class="form-input"
    [(ngModel)]="item.answerValue"
    (ngModelChange)="onValueChange($event)"
    placeholder="+x xxx xxx xx xx"
  />

  <!-- DATE Input -->
  <p-calendar
    *ngIf="item.type === FormTabItemTypeEnum.DATE"
    [showButtonBar]="true"
    appendTo="body"
    [(ngModel)]="item.answerValue"
    (ngModelChange)="onValueChange($event)"
  >
  </p-calendar>

  <!-- CHECKBOX Input -->
  <div
    *ngIf="item.type === FormTabItemTypeEnum.CHECKBOX"
    class="radio-container"
  >
    <div class="radio-options">
      <div *ngFor="let option of item?.typeData" class="radio-option">
        <label class="radio-label">
          <input
            type="radio"
            class="radio-input"
            [name]="'radio_' + item.id"
            [value]="option"
            [(ngModel)]="item.answerValue"
            (ngModelChange)="onRadioChange($event)"
          />
          <span class="radio-text">{{ getOptionLabel(option) }}</span>
        </label>
      </div>
    </div>

    <div *ngIf="showDescription" class="description-field">
      <label class="field-label required-star" for="">Açıklama</label>
      <textarea
        class="form-textarea"
        [(ngModel)]="item.description"
        (ngModelChange)="onValueChange($event)"
        placeholder="Lütfen açıklama giriniz..."
        rows="3"
        [attr.maxlength]="255"
      >
      </textarea>
      <div class="text-end text-muted small">
        {{ currentLength }} / {{ 255 }}
      </div>
    </div>
  </div>

  <!-- SELECT Input -->
  <p-dropdown
    *ngIf="
      item.type === FormTabItemTypeEnum.SELECT ||
      item.type === FormTabItemTypeEnum.COUNTRY
    "
    [options]="item.dropdownOptions"
    appendTo="body"
    [(ngModel)]="item.answerValue"
    (ngModelChange)="onValueChange($event)"
    [filter]="true"
  ></p-dropdown>

  <!-- MULTISELECT Input -->
  <div
    *ngIf="item.type === FormTabItemTypeEnum.MULTISELECT"
    class="multiselect-container"
  >
    <p-multiSelect
      [options]="item.dropdownOptions"
      appendTo="body"
      [(ngModel)]="item.answerValue"
      (ngModelChange)="onValueChange($event)"
      [filter]="true"
    ></p-multiSelect>
  </div>

  <!-- FILE Input -->
  <div *ngIf="item.type === FormTabItemTypeEnum.FILE" class="file-container">
    <input
      type="file"
      class="file-input"
      #fileInput
      (change)="onFileChange($event)"
      multiple
      accept="image/*,.pdf,.doc,.docx"
    />
    <button type="button" class="file-button" (click)="fileInput.click()">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
      >
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <polyline points="7,10 12,15 17,10" />
        <line x1="12" y1="15" x2="12" y2="3" />
      </svg>
      Dosya Seç
    </button>
    <div *ngIf="selectedFiles.length > 0" class="selected-files">
      <div *ngFor="let file of selectedFiles" class="file-item">
        <span class="file-name">{{ file.name }}</span>
        <button type="button" class="remove-file" (click)="removeFile(file)">
          ×
        </button>
      </div>
    </div>
  </div>
</div>
